import React from "react";
import ReceptionPlacesList from "../components/ReceptionPlacesList";
import ReceptionPlacesPanel from "../panel/ReceptionPlacesPanel";
import ListSuccessMessage from "../../common/layout/ListSuccessMessage";
import { mergeStyles } from "office-ui-fabric-react";

const padding = mergeStyles({
    paddingTop: 15
})

const wrapper = mergeStyles({
    width: "95%",
    margin: "0px auto",
});

const ReceptionPlaces: React.FC = () => {
    return (
        <div className={wrapper}>
            <div className={padding}>
                <ListSuccessMessage />
            </div>
            <ReceptionPlacesList />
            <ReceptionPlacesPanel />
        </div>
    );
};

export default ReceptionPlaces;